export default __webpack_public_path__ + "static/media/elasticsearch.16b06d41.svg";